<template>
    <layout>
        <template v-slot:header>
            Term Reports Sign in
        </template>

        <template v-slot:username>
            <v-form 
                class="pa-5"
                @submit.prevent
            >
                <v-text-field
                    label="Username"
                    placeholder="Enter username"
                    name="id"                                                
                    type="text"
                    color="primary"
                    v-model="formData.name"
                    clearable
                    autofocus
                    v-on:keyup="keyPress"
                >
                    <v-icon
                        slot="prepend"
                        color="primary"
                    >
                        mdi-account
                    </v-icon>
                </v-text-field>
                <div class="text-right mt-4 mb-4">                                                
                    <v-btn 
                        color="primary" 
                        @click="nextStep" 
                        dark
                        block
                    >
                        NEXT
                    </v-btn>
                </div>
            </v-form>
        </template>

        <template v-slot:password>
            <v-form 
                class="pa-5"
                @submit.prevent="submit"
            >
                <v-text-field
                    v-show="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    :label="passwordLabel"
                    :placeholder="passwordPlaceholder"
                    :hint="passwordHint"
                    persistent-hint
                    @click:append="show = !show"                                                    
                    name="password"
                    v-model="formData.password"
                    clearable
                    autofocus
                >
                    <v-icon
                        slot="prepend"
                        color="primary"
                    >
                        mdi-key
                    </v-icon>
                </v-text-field>
            

                <div class="text-right mt-4  mb-4">
                    <v-btn color="primary" block @click="submit" dark>LOGIN</v-btn>
                </div>
            </v-form>             
        </template>

    </layout>
</template>

<script>
import Layout from '../layouts/Login';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'LoginTermReports',
    components: {
        Layout
    },
    data: () => ({
        formData: {
            name: '',
            password: '',            
        },
        show: false,        
        passwordPlaceholder: 'Enter password',
        passwordLabel: 'Password',
        passwordHint: '',
        password: true,
    }),
    computed: {
        ...mapGetters({            
            step: 'auth/getStep',
            authenticated: 'auth/getAuthenticated',
            resetPassword: 'auth/getResetPassword',                        
        }),        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/employeeSignIn', 
            getUser: 'auth/user',          
        }),
        ...mapMutations({
            loginError: 'auth/setLoginErrors', 
            setStep: 'auth/setStep',
            setOverlay: 'auth/setOverlay',
            setUserName: 'auth/setUserName',
            setResetPassword: 'auth/setResetPassword',
            setExpand: 'auth/setExpand',          
        }),
        async submit () {            
            console.log('Authenticating...');
            await this.signIn(this.formData);            
            if(this.authenticated){
                console.log('User Authenticated.');                
                //console.log(this.resetPassword);
                if(this.resetPassword){
                    setTimeout(() => {this.setOverlay(false)});
                    this.setStep(3);
                }
                else{
                    this.setExpand(false);                                       
                    setTimeout(() => {this.setOverlay(false)})
                    this.$router.replace('/term-reports');
                }
                
            }
            else{
                console.log('Not authenticated');
            }

        },
        async nextStep () {
            this.setStep(2);
            this.setUserName(this.formData.name);
        },
        keyPress (e) {
            if(e.keyCode === 13){
                this.nextStep();
            }
        },
        
    },
}
</script>